import React from 'react';
import { Funnel } from '@phosphor-icons/react';
import SearchInternational from '../SearchInternational';

function SelectFake({ label, value, onChange, options = [] }) {
  return (
    <div
      style={{
        width: 'calc(33.33% - 12px)',
        minWidth: '180px',
        marginBottom: '1rem',
      }}
    >
      <p
        style={{
          fontSize: '0.8rem',
          marginBottom: '0.35rem',
          color: '#6b7280',
        }}
      >
        {label}
      </p>

      <select
        value={value}
        onChange={onChange}
        style={{
          width: '100%',
          border: 'none',
          borderBottom: '1px solid #cbd5e1',
          outline: 'none',
          background: 'transparent',
          padding: '0.4rem 0',
          fontSize: '0.95rem',
          color: '#374151',
        }}
      >
        {options.map((item) => (
          <option key={item.value} value={item.value}>
            {item.label}
          </option>
        ))}
      </select>
    </div>
  );
}

export default function AsideFiltersReits({
  searchFilters,
  setSearchFilters,
  onChangeSearch,
  searchPlaceholder,
  showMobileButton = false,
  onOpenMobileFilters,
}) {
  function updateFilter(field, value) {
    setSearchFilters((prev) => ({
      ...prev,
      [field]: value,
      isFiltered: true,
    }));
  }

  return (
    <div
      style={{
        width: '100%',
        background: '#ffffff',
        border: '1px solid #e5e7eb',
        borderRadius: '12px',
        padding: '16px 24px',
        height: 'fit-content',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <p
          style={{
            width: '100%',
            maxWidth: '18.75rem',
            fontWeight: '500',
            fontSize: '1rem',
            color: '#606060',
          }}
        >
          Filtros
        </p>

        {showMobileButton && (
          <button className="buttonFilter" onClick={onOpenMobileFilters}>
            <Funnel size={24} color="#505050" />
          </button>
        )}
      </div>

      <div style={{ width: '100%', marginBottom: '1rem' }}>
        <SearchInternational
          placeholder={searchPlaceholder}
          onChange={onChangeSearch}
          value={searchFilters.nome_ativo}
        />
      </div>

      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '12px 18px',
          alignItems: 'flex-start',
        }}
      >
        <SelectFake
          label="País"
          value={searchFilters.pais}
          onChange={(e) => updateFilter('pais', e.target.value)}
          options={[
            { label: 'Todos', value: '' },
            { label: 'Estados Unidos', value: 'usa' },
          ]}
        />

        <SelectFake
          label="Bolsa"
          value={searchFilters.bolsa}
          onChange={(e) => updateFilter('bolsa', e.target.value)}
          options={[
            { label: 'Todas', value: '' },
            { label: 'NYSE', value: 'NYSE' },
            { label: 'NASDAQ', value: 'NASDAQ' },
          ]}
        />

        <SelectFake
          label="Tipo de REIT"
          value={searchFilters.segmento}
          onChange={(e) => updateFilter('segmento', e.target.value)}
          options={[
            { label: 'Todos', value: '' },
            { label: 'Industrial', value: 'industrial' },
            { label: 'Retail', value: 'retail' },
            { label: 'Residential', value: 'residential' },
            { label: 'Healthcare', value: 'healthcare' },
          ]}
        />
      </div>
    </div>
  );
}